<template>
  <b-tabs 
    class="supplierDetailTabs" 
    card 
    @activate-tab="changedTabs"  
    v-model="currentTab" 
    ref="detailTabs"
  >
    <!-- 勿加 disabled：会锁死整页点击；仅作分组容器 -->
    <fieldset>
      <!-- 首页 -->
      <b-tab :active="currentTab === CurrentTab.tab">
        <template slot="title">
          <feather type="home"></feather>{{ $t("Lbl_Home") }}
        </template>
        <component  is="Home" ref="home"  :simulatedSupplier="simulatedSupplier"  v-if="currentTab==0" :key="simulatedSupplier.empCompanyId"
        />
      </b-tab>
      
      <!-- 公司信息 -->
      <b-tab :active="currentTab === CurrentTab.tab">
        <template slot="title">
          <feather type="aperture"></feather>{{ $t("lbl_EMPBE_CompanyInfo") }}
          <span class="toBeApprovalTip" v-if="simulatedSupplier.compinfoStatus&&(simulatedSupplier.compinfoStatus.includes('P')||simulatedSupplier.compinfoStatus.includes('PA'))"></span>
        </template>
        <component  is="companyInfoCenter"  ref="companyInfo"  :supplierId="supplierId" submit-type="approval" v-if="supplierId&&currentTab==1"  :key="'company_' + supplierId" @approval-status-change="onCompanyApprovalStatusChange"/>
      </b-tab>
      
      <!-- 产品资料 -->
      <b-tab :active="currentTab === CurrentTab.tab">
        <template slot="title">
          <feather type="shopping-bag"></feather>{{ $t("lbl_EMPBE_ProductInfo") }}
           <span class="toBeApprovalTip" v-if="simulatedSupplier.prodInfoStatus&&simulatedSupplier.prodInfoStatus.includes('PA')"></span>
        </template>
        <component
          is="productInfoCenter"
          ref="productInfo"
          v-if="supplierId&&currentTab==2"
          :supplierId="supplierId"
          submit-type="approval"
          :key="'product_' + supplierId"
          @detail-visibility-change="onProductDetailVisibilityChange"
        />
      </b-tab>
    </fieldset>
    
 <!-- PIG -->
    <b-tab  :active="currentTab === CurrentTab.tab" >
      <template slot="title" >
        <img v-if="currentTab==3"  style="margin-right:10px;width: 24px;" src="https://cdn.adsalecdn.com/EMP/Backend/svg/PIG/EMPBE_Menu_PIG_Icon.svg" >
        <img v-else style="margin-right:10px;width: 24px;" src="https://cdn.adsalecdn.com/EMP/Backend/svg/PIG/EMPBE_Menu_PIG_None_Icon.svg" >
        <span >PIG</span>
         <span class="toBeApprovalTip" v-if="simulatedSupplier.pigStatus&&(simulatedSupplier.pigStatus.includes('P')||simulatedSupplier.pigStatus.includes('PA'))"></span>
      </template>
      <component is="PIGPage" ref="PIGPage" :IsStrus="0"  v-if="currentTab==3" :supplierId="supplierId" submit-type="approval" :key="'PIGPage_' + supplierId"/>
    </b-tab>

    
    <!-- BR -->
    <b-tab  :active="currentTab === CurrentTab.tab" >
      <template slot="title" >
        <img v-if="currentTab==4"  style="margin-right: 10px;"  src="https://cdn.adsalecdn.com/EMP/Backend/svg/BR/BRIconSelected.svg" >
        <img v-else style="margin-right: 10px;"  src="https://cdn.adsalecdn.com/EMP/Backend/svg/BR/BRIcon.svg" >
        <span >{{ $t("lbl_EMPBE_BusinessDocuments") }}</span>
        <span class="toBeApprovalTip" v-if="simulatedSupplier.brStatus&&(simulatedSupplier.brStatus.includes('P')||simulatedSupplier.brStatus.includes('PA'))"></span>
      </template>
      <component 
      is="SupplierBusinessDocuments"
      ref="businessDocuments"
      v-if="currentTab==4" 
      :supplierId="supplierId"
      :simulatedSupplier="simulatedSupplier"
      submit-type="approval" 
      :key="'BR_' + supplierId"
      :show-approval-actions="true"
      />
    </b-tab>
    
  
    <!-- 操作日志（放最后，避免影响原有 Tab 索引/逻辑） -->
    <b-tab>
      <template slot="title">
        <feather type="file-text"></feather>{{ $t("lbl_EMPBE_OpLog_TabTitle") }}
      </template>
      <component
        is="SupplierOperationLog"
        ref="operationLog"
        :supplierId="supplierId"
        :simulatedSupplier="simulatedSupplier"
        v-if="currentTab==5"
        :key="'oplog_' + supplierId"
      />
    </b-tab>
    
    <div slot="tabs-end" class="mr-auto"></div>

    <!-- 底部按钮 -->
     
    <div class="customizer-formbutton" v-if="currentTab != 0 && !['PIGPage','SupplierOperationLog','SupplierBusinessDocuments'].includes(CurrentTab.name)">
      <b-button-group> 
        <b-button v-if="(CurrentTab.name === 'companyInfoCenter' && isShowCompanyBtn_Save) || isShowBtn_Save" 
          class="btn btn-save btn-lg m-r-5" 
          @click="onApprovalSave">
          {{ $t("lbl_EMPBE_Save") }}
        </b-button> 
          <b-button v-if="(CurrentTab.name === 'companyInfoCenter' && isShowCompanyBtn_Finish) || isShowBtn_Finish" 
         class="btn btn-primary btn-lg" 
          @click="onApprovalFinish">
          {{ $t("lbl_EMPBE_APProval_btnFinish") }}
        </b-button> 
      </b-button-group>
    </div>

 
  </b-tabs>
</template>

<script>
import { computed } from "vue";
import { mapGetters } from 'vuex';
import companyInfoCenter from './supplierCompanyInfo.vue';
import productInfoCenter from './supplierProductInfo.vue'; 
import DisableItemVue from '../RightPopUp/DisableItem.vue';
import { adService, userService } from '@/_services';
import Home from '../../dashboard/default.vue';  
import SupplierOperationLog from './supplierOperationLog.vue';
import SupplierBusinessDocuments from './supplierBusinessDocuments.vue';
import PIGPage from '../../PIG/default.vue';

export default {
  name: 'SupplierDetailTabs',
  components: {
    companyInfoCenter,
    productInfoCenter, 
    DisableItemVue, 
    Home, 
    SupplierOperationLog,
    SupplierBusinessDocuments,
    PIGPage
  },
  provide() {
    return { 
      permissionData: computed(() => this.permissionData) 
    }
  },
  props: ['supplierId', 'text_data', 'simulatedSupplier', 'sidebarStrus',"openTabIndex","fromPage"],
  data() {
    return {
      permissionData: null,
      //visitedTabs: [0],
      currentTab: 0,
      isediting: true,
      rejectReason: '',
      isFirstLoad: true,
      isAdPendingApproval:false,
      isAdApprovalApproval:false,
      tabList: [
        {
          name: 'Home',
          tab: 0,
          editable: true
        }, 
        {
          name: 'companyInfoCenter',
          tab: 1,
          editable: true
        },
        {
          name: 'productInfoCenter',
          tab: 2,
          editable: true
        },
        {
          name: 'PIGPage',
          tab: 3,
          editable: false
        }, 
         {
          name: 'SupplierBusinessDocuments',
          tab: 4,
          editable: true
        },
        {
          name: 'SupplierOperationLog',
          tab: 5,
          editable: false
        },
         
        
      ],
      isProductInfo:false,
      productId:0,
      productStatus:-1,
      isShowBtn_Save: false,
      isShowBtn_Finish: false,
      isShowCompanyBtn_Save: false,
      isShowCompanyBtn_Finish: false,
      isSaveLocked: false,
      saveLockTimer: null,
      saveDebounceMs: 1200,
    };
  },
  computed: {
    CurrentTab() {
      return this.tabList.find(tab => tab.tab === this.currentTab);
    },
    isSuperAdmin() {
      const currentUser = this.$store?.state?.authentication?.user;
      return currentUser && currentUser.IsFullAccess === true;
    },
    validSupplierId() {
      if (!this.supplierId) {
        return null;
      }
      
      const id = Number(this.supplierId);
      
      if (isNaN(id) || id <= 0 || id === -1) {
        return null;
      }
      
      return id;
    },
    ...mapGetters({
      getPermissionJsonByUser: 'responsePermission/getPermissionJsonByUser',
    }),
    user() {
      return this.$store.state.authentication.user;
    },
    companyid() {
      return this.supplierId || this.user?.empCompanyId || '';
    },
    langid() {
      return localStorage.getItem('currentLangId');
    },
    GetTabRef() {
      return "tab" + this.TabIndex;
    },
  },
  watch: {
      sidebarStrus(val) {
        if (!val) {
          this.currentTab = 0;
          return;
        }
        // 打开侧栏时优先 URL / openTabIndex，避免总是回到 Home
        this.applyUrlOrOpenTab();
      },
    currentTab(newTab, oldTab) {
      const myUsersTabIndex = this.getTabByName('MyUsers');
      
      if (oldTab === myUsersTabIndex && newTab !== myUsersTabIndex) {
        if (this.$store && this.$store.state) {
          this.$store.state.dirty = false;
        }
      }
      
      if (newTab === myUsersTabIndex && oldTab !== myUsersTabIndex) {
        if (this.$store && this.$store.state) {
          this.$store.state.dirty = false;
        }
      }
    },
    supplierId: {
      handler() {
        this.refresh();
      },
      immediate: true
    }, 
  },
  mounted() {
    console.log('fromPage'+this.fromPage)
    this.applyUrlOrOpenTab();
  },
  beforeDestroy() {
    if (this.saveLockTimer) {
      clearTimeout(this.saveLockTimer);
      this.saveLockTimer = null;
    }
  },
  methods: {

    /**
     * 判断是否应该渲染当前tab
     */
    // shouldRenderTab(tabIndex) {
    //   return this.visitedTabs.includes(tabIndex);
    // },
    
    adTabChangeFunc(approvalStatus) {
        this.isAdPendingApproval = (approvalStatus ?? "")=== "P";
        this.isAdApprovalApproval = (approvalStatus ?? "")=== "A";
    },
    
    getTabByName(name) {
      const tab = this.tabList.find(tab => tab.name === name);
      return tab ? tab.tab : 0;
    },
    
    /**
     * 切换标签页
     */
    changedTabs(newTabIndex, prevTabIndex) {
      const myUsersTabIndex = this.getTabByName('MyUsers');
      
      if (prevTabIndex === myUsersTabIndex && newTabIndex !== myUsersTabIndex) {
        if (this.$store && this.$store.state) {
          this.$store.state.dirty = false;
        }
      }
      
      if (newTabIndex === myUsersTabIndex && prevTabIndex !== myUsersTabIndex) {
        if (this.$store && this.$store.state) {
          this.$store.state.dirty = false;
        }
      }
      
      // Reset product detail view when entering product tab
      if (newTabIndex === 2 && this.$refs.productInfo) {
        this.$refs.productInfo.temp_productId = 0;
        this.$refs.productInfo.temp_catalogId = 0;
        this.$refs.productInfo.isShowDetail = false;
        this.isShowBtn_Save = false;
        this.isShowBtn_Finish=false;
      }
      if (newTabIndex !== 2) {
        this.isShowBtn_Save = false;
        this.isShowBtn_Finish=false;
      }

      // 操作日志：v-if 挂载后由子组件按默认日期拉一次列表（nextTick 确保 ref 就绪）
      const oplogTabIndex = this.getTabByName('SupplierOperationLog');
      if (newTabIndex === oplogTabIndex) {
        this.$nextTick(() => {
          const oplog = this.$refs.operationLog;
          if (oplog && typeof oplog.bootstrapFromTab === 'function') {
            oplog.bootstrapFromTab();
          }
        });
      }
    },
    
    /**
     * 刷新页面
     */
    refresh() {
      this.currentTab = this.openTabIndex>0?this.openTabIndex:0;
      this.isShowBtn_Save = false;
      this.isShowBtn_Finish=false;
      //this.visitedTabs = [0];  
      if (this.companyid) {
        this.GetSysCompanySponsorType();
      }
      if(this.$refs.rejectSidebar){
      this.$refs.rejectSidebar.hide();
      }
    },

    /** 根据 URL 的 type / tab / productId 或 openTabIndex 打开对应 tab */
    applyUrlOrOpenTab() {
      const q = this.$route.query || {};
      const key = String(q.type || q.tab || "").toLowerCase();
      const tabMap = {
        home: "Home",
        company: "companyInfoCenter",
        comp: "companyInfoCenter",
        product: "productInfoCenter",
        prod: "productInfoCenter",
        pig: "PIGPage",
        br: "SupplierBusinessDocuments",
      };
      let tabIndex = this.openTabIndex > 0 ? Number(this.openTabIndex) : 0;
      if (key && tabMap[key]) {
        tabIndex = this.getTabByName(tabMap[key]);
      } else if (q.productId || q.catalogId) {
        tabIndex = this.getTabByName("productInfoCenter");
      }
      this.currentTab = tabIndex;
    },
    
    //old ad
    async todoApproval() {
      this.$swal({
        text: this.$t("lbl_EMPBE_ApproveThisAd"),
        showCancelButton: true,
        confirmButtonText: this.$t('lbl_EMPBE_Confirm'),
        cancelButtonText: this.$t('lbl_EMPBE_Cancel'),
      }).then(async (res) => {
        if (res.isConfirmed) {
          try {
            const Params = await this.AdGetParam('APPROVAL', 'A');
            const response = await adService.adApprove(Params);
            
            if (response.isSuccessful && response.statusCode === 200) {
              this.$swal({
                text: this.$t("lbl_EMPBE_PassApproval"),
                showCancelButton: false,
              });
              this.$refs.adInfo.refresh();
            }
          } catch (err) {
          }
        }
      });
    },
    
    GetSysCompanySponsorType() {
      if (!this.companyid) return;
      
      userService.GetSysCompanySponsorType({ CompanyId: this.companyid })
        .then(res => {
          if (res.isSuccessful) {
            this.permissionData = this.getPermissionJsonByUser({ 
              user: res.data 
            });
          }
        });
    },
    parentHandlBtn(productId,status){
    this.isProductInfo=true;
    this.productId=productId;
    this.productStatus=status
    },
    onProductDetailVisibilityChange({ isShowDetail, isProductDetail,LanuchStatus }) {
      this.isShowBtn_Save = !!(isShowDetail && isProductDetail)&&(LanuchStatus&&(LanuchStatus=='PA'));
      this.isShowBtn_Finish=!!(isShowDetail && isProductDetail)&&(LanuchStatus&&(LanuchStatus=='PA'||LanuchStatus=='R'));
    },
    onCompanyApprovalStatusChange(payload) {
      const statusCode = payload && typeof payload === 'object'
        ? payload.statusCode
        : payload;
      const code = String(statusCode || '').trim().toUpperCase();
      const pending = code === 'P' || code === 'PA';
      this.isShowCompanyBtn_Save = pending;
      this.isShowCompanyBtn_Finish = pending || code === 'R';
    },
    /** 审批页保存：产品详情内保存驳回内容 */
    async onApprovalSave() {
      let response = false;
       switch (this.CurrentTab.name) {
            case 'companyInfoCenter':
              if (this.isShowCompanyBtn_Save && this.$refs.companyInfo) {
                response = await this.$refs.companyInfo.saveApprovalRejectContent();
              }
              break;
            case 'productInfoCenter':
              if (this.isShowBtn_Finish && this.$refs.productInfo) {
              response = await  this.$refs.productInfo.saveApprovalRejectContent();
              }
            break;
          } 
      if (response||(response.isSuccessful && response.statusCode === 200)) {
        this.$swal({
          text: this.$t("lbl_EMPBE_Oprate_Scuessfully"),
          showCancelButton: false,
        });
        
      }
    },
    /** 审批页完成：产品/公司详情内按总驳回框决定通过/驳回，并显示对应结果弹窗 */
    async onApprovalFinish() {
      let result = null;
      switch (this.CurrentTab.name) {
        case 'companyInfoCenter':
          if (this.isShowCompanyBtn_Finish && this.$refs.companyInfo) {
            result = await this.$refs.companyInfo.finishCompanyApproval();
          }
          break;
        case 'productInfoCenter':
          if (this.isShowBtn_Finish && this.$refs.productInfo) {
            result = await this.$refs.productInfo.finishProductApproval();
          }
          break;
        default:
          break;
      }
      if (!result || !result.ok) return;
      const isReject = String(result.statusCode || '').toUpperCase() === 'R';
      this.$swal({
        text: this.$t(
          isReject
            ? 'lbl_EMPBE_ProductInfo_RejectSuccess'
            : 'lbl_EMPBE_PassApproval'
        ),
        showCancelButton: false,
      });
      this.$emit('approval-finished', {
        statusCode: result.statusCode,
        empCompanyId: this.supplierId,
        tab: this.CurrentTab && this.CurrentTab.name,
      });
    },
  }
};
</script>
<style scoped>
.toBeApprovalTip{
  width: 8px; 
  height: 8px; 
  background: #FFD02C; 
  border-radius: 9999px;
  position: absolute;
  right: 4px;
  top: 0.5rem;
  }
</style>
<style >
 .supplierDetailTabs fieldset {
  border: none; 
  padding: 0
}
  #company-approval-sidebar .card-header:nth-child(1) {
    width: 98%;
    margin-left: 32px;
}  
  #company-approval-sidebar .card-header:nth-child(n+2)  {
    width: unset;
    margin-left: unset !important;
}  
  #company-approval-sidebar .card-header {
    width: unset;
    margin-left: unset !important;
}
#company-approval-sidebar .nav-tabs .nav-link{
    align-items: center;
    justify-content: center;
    display: flex;
    height: 100%;
    color: rgba(0, 0, 0, 0.80);
    position: relative;
} 
#company-approval-sidebar .nav-tabs .nav-link:hover {  
    color: rgba(0, 0, 0, 0.80);
    border-color: #F2F3F5;
}
#company-approval-sidebar .nav-tabs .nav-link.active,#company-approval-sidebar .nav-tabs .nav-link.active:hover{
    border: 1px solid transparent ;
    border-bottom: solid 2px #7366FF; 
    color: #7366FF;
    background-color: unset; 
}
#company-approval-sidebar .btn-group > .btn:not(:first-child), .btn-group > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: unset !important;
     border-bottom-left-radius: unset !important;
}
 #company-approval-sidebar .btn-save{
 background-color: #fff !important;
  border-color: rgba(0, 0, 0, 0.15) !important;
   color: rgba(0, 0, 0, 0.80)!important
}
 #company-approval-sidebar .btn-primary {
    background-color: var(--theme-deafult) !important;
    border-color: var(--theme-deafult) !important;
}
</style>